import React from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { useRecoilValue } from 'recoil';
import { Box, LinkButton } from '@tq/ui-components';

import { hasPermissionState } from 'store';
import { useBreadcrumb } from '../../hooks';

export type BreadcrumbProps = {
  location: string;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ location }) => {
  const hasPermission = useRecoilValue(hasPermissionState);
  const { navigationLabel, handleNavigateClick } = useBreadcrumb(location);

  return hasPermission ? (
    <Box width='100%' py={{ base: 0, lg: 4 }}>
      <LinkButton leftIcon={<FaChevronLeft />} onClick={handleNavigateClick}>
        {navigationLabel()}
      </LinkButton>
    </Box>
  ) : (
    <></>
  );
};
